import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
    selector: 'app-learning-path-status-widget-demo',
    templateUrl: './learning-path-status-widget-demo.component.html',
    styleUrl: './learning-path-status-widget-demo.component.scss',
    standalone: false
})
export class LearningPathStatusWidgetDemoComponent {
  rawData = [
    { learningPathId: 1, learningPathName: 'Basics', completedCourses: 3, openCourses: 2 },
    { learningPathId: 2, learningPathName: 'Advanced', completedCourses: 1, openCourses: 4 },
  ];

  learningPathsProgressData = this.rawData
    .map((item) => {
      const total = item.completedCourses + item.openCourses;
      const progressPercentage = total > 0 ? Math.round((item.completedCourses / total) * 100) : 0;
      return {
        id: item.learningPathId,
        name: item.learningPathName,
        progress: `${item.completedCourses} / ${total}`,
        progressPercentage,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  learningPathsProgressColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    }
  ];

  constructor(private translateService: TranslateService) {}
}
